import { Fragment, StrictMode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { setupInterceptors } from '@common/api/httpClient';
import { queryClient } from '@common/api/query';
import { isDemoState } from '@common/hooks/useDemoStatus';
import store from '@common/store';
import { removeUserAction } from '@common/store/reducers';
import Router from '@sw/containers/Router';
import '@common/styles/components/tecalor-overrides.pcss';
import '@common/styles/general/main.pcss';
import '@common/styles/stiebel-fonts.pcss';
import '@common/styles/tecalor-fonts.pcss';

if (module.hot) {
  module.hot.accept();
}

setupInterceptors(
  () => store.dispatch(removeUserAction()),
  () => isDemoState(store.getState().main.user),
  () => !!store.getState().main.mobileUserMode,
);

const ApplicationWrapper = NO_STRICT_MODE ? Fragment : StrictMode;
const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  (
    <ApplicationWrapper>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <Router />
        </Provider>
        {DEBUG && (
          <>
            {/* Initially closed as to not block parts of screen for integration tests */}
            <ReactQueryDevtools initialIsOpen={false} styleNonce="tanstack-devtools" />
          </>
        )}
      </QueryClientProvider>
    </ApplicationWrapper>
  ),
);
